import { FC, lazy } from 'react'
import { RouteObject, useLocation } from 'react-router-dom'
import { LazyComponent } from '../features/lazy-component'
import { Segment } from '../features/segment'

const SongPreview = lazy(() => import('../__legacy__/components/detail-pages/song/SongPreviewPage'))

const SongPreviewPage: FC = () => {
  const { pathname } = useLocation()
  return (
    <Segment.ViewTracker attributes={{ path: '/song-preview', jobId: pathname.split('/')[2] }}>
      <LazyComponent>
        <SongPreview />
      </LazyComponent>
    </Segment.ViewTracker>
  )
}

export const SongPreviewRoute: RouteObject = {
  path: '/song-preview/:jobId',
  element: <SongPreviewPage />
}
